import './Header.css';

export default function Header() {
  return (
    <header>
      <div id='h1-container'>
        <h1><span id='reddit'>reddit</span><span id='lite'>Lite</span></h1>
      </div>
    </header>
  );
}